<template>
    <div class="page-content margin-bottom-60">
        <div class="center-text own-title margin-bottom-10">
            Talent Profiling Guide
        </div>
        <div class="content margin-bottom-10">
            <a href="/talent-profiling-guide">
                <img :src="'images/mpower-new/career/back-arrow.png'" />
            </a>
        </div>
        <div class="content">
            <div class="talent-question-title margin-bottom-10 text-left">
                {{data[loadIndex].title}}
            </div>
            <div class="talent-question-desc line-height-normal text-left">
                {{data[loadIndex].description}} 
            </div>
        </div>
        <div class="content" v-for="(item,index) in data[loadIndex].question" :key="index">
            <div class="talent-category margin-bottom-10 text-left">
                {{item.section}}
            </div>
            <div v-for="(subitem,index) in item.question" :key="index">
                <div class="talent-left-wrapper">
                    <label v-if="subitem.index!='10'" class="talent-label text-left">
                        {{subitem.title}}
                    </label>
                    <label v-else class="talent-label text-left">
                        <strong>{{subitem.title}}</strong>
                    </label>
                </div>
                <div class="talent-right-wrapper">
                    <label v-if="item.section.toLowerCase()=='g' && subitem.index!='10'" :class="setg.includes('option'+subitem.index)?'talent-option label-highlight':'talent-option'">
                        <input v-model="setg" :value="'option'+subitem.index" class="custom-input" type="checkbox" name="interest_g[]" @change="check(setg,'g')">
                    </label>
                    <label v-if="item.section.toLowerCase()=='g' && subitem.index=='10'" class="talent-option talent-option-text total_number_g">
                        <input v-model="setg" class="custom-input-text total_number_g" type="number" name='total_number_g' readonly>
                    </label>

                    <label v-if="item.section.toLowerCase()=='e' && subitem.index!='10'" :class="sete.includes('option'+subitem.index)?'talent-option label-highlight':'talent-option'">
                        <input v-model="sete" :value="'option'+subitem.index" class="custom-input" type="checkbox" name="interest_e[]" @change="check(sete,'e')">
                    </label>
                    <label v-if="item.section.toLowerCase()=='e' && subitem.index=='10'" class="talent-option talent-option-text total_number_e">
                        <input v-model="sete" class="custom-input-text total_number_e" type="number" name='total_number_e' readonly>
                    </label>

                    <label v-if="item.section.toLowerCase()=='n' && subitem.index!='10'" :class="setn.includes('option'+subitem.index)?'talent-option label-highlight':'talent-option'">
                        <input v-model="setn" :value="'option'+subitem.index" class="custom-input" type="checkbox" name="interest_n[]" @change="check(setn,'n')">
                    </label>
                    <label v-if="item.section.toLowerCase()=='n' && subitem.index=='10'" class="talent-option talent-option-text total_number_n">
                        <input v-model="setn" class="custom-input-text total_number_n" type="number" name='total_number_n' readonly>
                    </label>
                </div>
            </div>
            <div class="clear"></div>
        </div>
        <div class="talent-button-wrapper">
            <a @click="proceed()" class="generali-button-red">
                {{data[loadIndex].button}}
            </a>
        </div>
    </div>
</template>
<style scoped>
</style>
<script>
export default {
    name: "Question_set_a",
    data(){
        return {
            setg: [],
            sete: [],
            setn: [],
            conclusion: {},
            loadIndex: 0,
            data: [{
                "language": "en",
                "title": "I. Interest",
                "description": "Place a tick ( ✔ ) in the box against those items that really interest you. You can tick as many as you want.",
                "question": [{
                    "section": "G",
                    "question": [{
                        "index": 1,
                        "title": "Fix electrical things"
                    },{
                        "index": 2,
                        "title": "Repair Cars"
                    },{
                        "index": 3,
                        "title": "Build things with wood"
                    },{
                        "index": 4,
                        "title": "Drive a truck or tractor"
                    },{
                        "index": 5,
                        "title": "Fix mechanical things"
                    },{
                        "index": 6,
                        "title": "Working with metal or machine tools"
                    },{
                        "index": 7,
                        "title": "Take Auto Mechanic course"
                    },{
                        "index": 8,
                        "title": "Take Woodworking course"
                    },{
                        "index": 9,
                        "title": "Work on a motorcycle"
                    },{
                        "index": 10,
                        "title": "TOTAL no. of ticks"
                    }]
                },{
                    "section": "E",
                    "question": [{
                        "index": 1,
                        "title": "Read scientific books or magazines"
                    },{
                        "index": 2,
                        "title": "Work in a laboratory"
                    },{
                        "index": 3,
                        "title": "Work on a scientific project"
                    },{
                        "index": 4,
                        "title": "Read specialist subjects on my own"
                    },{
                        "index": 5,
                        "title": "Solve Mathematical or chess puzzles"
                    },{
                        "index": 6,
                        "title": "Take Physics course"
                    },{
                        "index": 7,
                        "title": "Take Chemistry course"
                    },{
                        "index": 8,
                        "title": "Take Geometry course"
                    },{
                        "index": 9,
                        "title": "Take Biology course"
                    },{
                        "index": 10,
                        "title": "TOTAL no. of ticks"
                    }]
                },{
                    "section": "N",
                    "question": [{
                        "index": 1,
                        "title": "Create portraits, photographs or drawings"
                    },{
                        "index": 2,
                        "title": "Practice a musical instrument"
                    },{
                        "index": 3,
                        "title": "Design furniture or buildings"
                    },{
                        "index": 4,
                        "title": "Play in a band, group or orchestra"
                    },{
                        "index": 5,
                        "title": "Go to concerts or stage show"
                    },{
                        "index": 6,
                        "title": "Drawing or sketching"
                    },{
                        "index": 7,
                        "title": "Read plays"
                    },{
                        "index": 8,
                        "title": "Read or write poetry"
                    },{
                        "index": 9,
                        "title": "Take Art course"
                    },{
                        "index": 10,
                        "title": "TOTAL no. of ticks"
                    }]
                }],
                "answer": "Yes",
                "button": "Proceed"
            },{
                "language": "cn",
                "title": "I. 兴趣",
                "description": "在那些你感兴趣的领域里画 （ ✔ ）。 你可以选择超过一个。",
                "question": [{
                    "section": "G",
                    "question": [{
                        "index": 1,
                        "title": "安装电器"
                    },{
                        "index": 2,
                        "title": "修理汽车"
                    },{
                        "index": 3,
                        "title": "使用木材制造物品"
                    },{
                        "index": 4,
                        "title": "驾驶罗里或拖拉机"
                    },{
                        "index": 5,
                        "title": "安装机械工具"
                    },{
                        "index": 6,
                        "title": "使用金属加工或机器工具"
                    },{
                        "index": 7,
                        "title": "修读自动技工课程"
                    },{
                        "index": 8,
                        "title": "修读木工课程"
                    },{
                        "index": 9,
                        "title": "研究电单车"
                    },{
                        "index": 10,
                        "title": "✔ 的数量"
                    }]
                },{
                    "section": "E",
                    "question": [{
                        "index": 1,
                        "title": "阅读科学书籍或杂志"
                    },{
                        "index": 2,
                        "title": "在实验室工作"
                    },{
                        "index": 3,
                        "title": "从事科学研究项目"
                    },{
                        "index": 4,
                        "title": "自修专科科目"
                    },{
                        "index": 5,
                        "title": "破解数学或象棋谜题"
                    },{
                        "index": 6,
                        "title": "修读物理学课程"
                    },{
                        "index": 7,
                        "title": "修读化学课程"
                    },{
                        "index": 8,
                        "title": "修读几何学课程"
                    },{
                        "index": 9,
                        "title": "修读生物学课程"
                    },{
                        "index": 10,
                        "title": "✔ 的数量"
                    }]
                },{
                    "section": "N",
                    "question": [{
                        "index": 1,
                        "title": "创作人像画、照片或绘画"
                    },{
                        "index": 2,
                        "title": "演奏乐器"
                    },{
                        "index": 3,
                        "title": "设计家具或建筑物"
                    },{
                        "index": 4,
                        "title": "参加乐队、乐团或管弦乐队"
                    },{
                        "index": 5,
                        "title": "观赏音乐会或演唱会"
                    },{
                        "index": 6,
                        "title": "绘画或素描"
                    },{
                        "index": 7,
                        "title": "阅读游戏"
                    },{
                        "index": 8,
                        "title": "朗诵诗歌或写诗"
                    },{
                        "index": 9,
                        "title": "修读艺术课程"
                    },{
                        "index": 10,
                        "title": "✔ 的数量"
                    }]
                }],
                "answer": "是",
                "button": "继续"
            },{
                "language": "bm",
                "title": "I. Minat",
                "description": "Sila tanda ( ✔ ) di dalam kotak terhadap semua perkara-perkara yang anda berminat. Anda boleh tanda seberapa banyak yang anda mahu.",
                "question": [{
                    "section": "G",
                    "question": [{
                        "index": 1,
                        "title": "Memperbaiki barang-barang elektrik"
                    },{
                        "index": 2,
                        "title": "Memperbaiki kereta"
                },{
                        "index": 3,
                        "title": "Membina barang-barang dengan kayu"
                    },{
                        "index": 4,
                        "title": "Memandu trak atau traktor"
                    },{
                        "index": 5,
                        "title": "Memperbaiki benda-benda mekanikal"
                    },{
                        "index": 6,
                        "title": "Bekerja dengan logam atau peralatan mesin"
                    },{
                        "index": 7,
                        "title": "Mengambil kursus mekanik kereta"
                    },{
                        "index": 8,
                        "title": "Mengambil kursus pertukangan kayu"
                    },{
                        "index": 9,
                        "title": "Pekerjaan berkenaan dengan motosikal"
                    },{
                        "index": 10,
                        "title": "Bilangan ✔"
                    }]
                },{
                    "section": "E",
                    "question": [{
                        "index": 1,
                        "title": "Baca buku-buku atau majalah saintifik"
                    },{
                        "index": 2,
                        "title": "Bekerja di makmal"
                    },{
                        "index": 3,
                        "title": "Kerja dalam satu project saintifik"
                    },{
                        "index": 4,
                        "title": "Membaca mata pelajaran khusus diri sendiri"
                    },{
                        "index": 5,
                        "title": "Menyelesaikan matematik atau teka-teki catur"
                    },{
                        "index": 6,
                        "title": "Mengambil kursus fizik"
                    },{
                        "index": 7,
                        "title": "Mengambil kursus kimia"
                    },{
                        "index": 8,
                        "title": "Mengambil kursus geometri"
                    },{
                        "index": 9,
                        "title": "Mengambil kursus biologi"
                    },{
                        "index": 10,
                        "title": "Bilangan ✔"
                    }]
                },{
                    "section": "N",
                    "question": [{
                        "index": 1,
                        "title": "Mencipta potret, gambar atau lukisan"
                    },{
                        "index": 2,
                        "title": "Berlatih alat muzik"
                    },{
                        "index": 3,
                        "title": "Mereka perabot atau bangunan"
                    },{
                        "index": 4,
                        "title": "Main dalam band, kumpulan atau orkestra"
                    },{
                        "index": 5,
                        "title": "Pergi ke konsert atau persembahan pentas"
                    },{
                        "index": 6,
                        "title": "Melukis"
                    },{
                        "index": 7,
                        "title": "Membaca drama"
                    },{
                        "index": 8,
                        "title": "Membaca atau menulis puisi"
                    },{
                        "index": 9,
                        "title": "Ambil kursus seni"
                    },{
                        "index": 10,
                        "title": "Bilangan ✔"
                    }]
                }],
                "answer": "Ya",
                "button": "Teruskan"
            }]
        }
    },
    mounted(){
        if(localStorage.getItem('talent_test')){
            try{
                this.conclusion = JSON.parse(localStorage.getItem('talent_test'))
                for(var a = 0; a < this.data.length; a++){
                    if(this.conclusion.language==this.data[a].language){
                        this.loadIndex = a
                    }
                }
            }
            catch(e){
                console.log(e)
                localStorage.removeItem('talent_test')
            }
        }
    },
    methods: {
        check(set,setname) {
            this.$el.querySelector(".total_number_"+setname).innerText = set.length;
        },
        proceed(){
            this.conclusion.g1 = 0;
            this.conclusion.e1 = 0;
            this.conclusion.n1 = 0;

            if(this.setg.length > 0){
                for(var g = 0 ; g < (this.setg.length); g++){
                    this.conclusion.g1 += 1;
                }   
            }
            if(this.sete.length > 0){
                for(var e = 0; e < this.sete.length; e++){
                    this.conclusion.e1 += 1;
                }
            }
            if(this.setn.length > 0){
                for(var n = 0; n < this.setn.length; n++){
                    this.conclusion.n1 += 1;
                }
            }
            console.log(this.conclusion)
            localStorage.setItem('talent_test',JSON.stringify(this.conclusion))
            window.scrollTo(0,0);
            this.$router.push({
                path: 'question-set-b'
            })
        },
        scrollToTop() {
            window.scrollTo(0,0);
        }
    }
}
</script>